<div id="common-selection-attributes" *ngIf="bajaSelected">
    <legend>Attributos</legend>
    <ng-select   [items]="padres"  class="formAtributos"
    bindLabel="parent" [(ngModel)]="selectedParent" (change)="onParentSelect($event)" [clearSearchOnAdd]="true">
    <div style="padding: 15px;"></div>
    </ng-select>
    
    <ng-select *ngIf="children.length > 0 || showChildren"
        [items]="children"
        bindLabel="texto" [(ngModel)]="AttributeModal" 
        [multiple]="true" [searchable]="true" (change)="saveAttribute($event)" id="filter-dropdown-panel">
        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled">Sin atributos para la empresa</div>
        </ng-template>
    </ng-select>
</div>

<div id="common-selection-attributes" *ngIf="!bajaSelected">
        <mat-label>Attributos</mat-label>
        <ng-select [items]="attributos$" [multiple]="true" [closeOnSelect]="true" [searchable]="true" bindLabel="texto"
            [(ngModel)]="AttributeModal" groupBy="parent" (change)="saveAttribute($event)" id="filter-dropdown-panel">
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">Sin atributos para la empresa</div>
            </ng-template>
            <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">Cargando atributos</div>
            </ng-template>
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                <div class="m-b-15 ng-value {{ item.parent }}" *ngFor="let item of items">
                    <span class="ng-value-label"> {{ item.texto }}</span>
                    <span class="ng-value-icon right m-b-10 m-l-5" (click)="clear(item)" aria-hidden="true">×</span>
                </div>
            </ng-template>
        </ng-select>
</div>